import { Helmet } from "react-helmet-async";
import { useLocation } from "react-router-dom";

// Paths (or prefixes) that must never be indexed by search engines.
// Auth, checkout, transactional, member/admin, QA and one-time links.
const NOINDEX_PREFIXES = [
  "/login",
  "/reset-password",
  "/verify-email",
  "/checkout",
  "/payment-success",
  "/payment-failed",
  "/unsubscribe",
  "/dashboard",
  "/settings",
  "/admin",
];

export const RouteNoindex = () => {
  const { pathname } = useLocation();
  const shouldNoindex = NOINDEX_PREFIXES.some(
    (p) => pathname === p || pathname.startsWith(`${p}/`)
  );
  if (!shouldNoindex) return null;
  return (
    <Helmet>
      <meta name="robots" content="noindex, nofollow" />
      <meta name="googlebot" content="noindex, nofollow" />
    </Helmet>
  );
};

export default RouteNoindex;
